<template>
    <AuthenticationBasic :title="$t('authentication.paySubscription')">
        <v-form
                ref="form"
                v-model="valid">
            <v-text-field
                    v-model="payment.cardNumber"
                    :label="$t('authentication.cardNumber')"
                    :rules="[$validations.required]"
                    class="mb-2"
                    placeholder="1234-1234-1234-1234"
                    required/>
            <v-btn
                    block
                    class="elevation-5 mt-5"
                    color="accent"
                    large
                    @click="pay">
                {{ $t('authentication.pay') }}
            </v-btn>
        </v-form>
    </AuthenticationBasic>
</template>

<script>
import AuthenticationBasic from "@/components/Authentication/AuthenticationBasic";

export default {
  name: "RegistrationPayment",
  components: {AuthenticationBasic},
  data() {
    return {
      valid: false,
      payment: {
        cardNumber: '',
      }
    };
  },
  methods: {
    pay() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.$router.push({name: 'login'});
    }
  }
};
</script>

<style scoped>

</style>